// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__1kdIj","navItem":"Nav_navItem__1BU4E","active":"Nav_active__1Hdb4"};